import api from '../../../lib/Api'

import { push } from 'connected-react-router'
import {
  fetchingSubscriptions,
  fetchingSubscriptionsError,
  replaceSubscription,
  setSelectedSubscription,
  setSubscriptionsSuccess,
} from './actions'

const searchSubscriptionsAndHandle = query => {
  return async dispatch => {
    dispatch(fetchingSubscriptions())

    if (!query) {
      dispatch(fetchingSubscriptionsError('You must provide a query'))
      return
    }

    const formattedQuery = !!query.subscriptionId
      ? `subscriptionId=${query.subscriptionId}`
      : `nsSubscriptionId=${query.nsSubscriptionId}`

    if (query.nsSubscriptionId || query.subscriptionId) {
      try {
        const response = await api.get(`/subscription?${formattedQuery}`)
        if (response.status === 204) {
          dispatch(setSubscriptionsSuccess([]))
          dispatch(push('/css-admin/subscriptions'))
        } else {
          const { id } = (response.data && response.data[0]) || {}
          dispatch(setSubscriptionsSuccess(response.data))
          dispatch(push(`/css-admin/subscriptions/${id}`))
        }
      } catch (error) {
        dispatch(fetchingSubscriptionsError(error))
      }
    } else {
      dispatch(
        fetchingSubscriptionsError(
          'Advanced subscription searching not implemented',
        ),
      )
    }
  }
}

const reloadSubscription = subscriptionId => {
  return async dispatch => {
    if (!subscriptionId) throw new Error('subscriptionId is required')

    dispatch(fetchingSubscriptions())

    try {
      const response = await api.get(
        `/subscription?subscriptionId=${subscriptionId}`,
      )
      const singleSubscription = response.data[0]
      dispatch(replaceSubscription(singleSubscription))
    } catch (error) {
      dispatch(fetchingSubscriptionsError(error))
    }
  }
}

export default {
  reloadSubscription,
  searchSubscriptionsAndHandle,
}



// WEBPACK FOOTER //
// ./src/redux/css-admin/subscriptionManager/operations.js